<template>
  <div class="row">
    <div class="col-12">
      {{ $t("search.mediate") }}
      <m-select
        class="search-form-field"
        v-model="search.BROKERAGEID"
        nolabel
        :options="options.brokerage"
      ></m-select>
    </div>
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.AGENTTITLE"
        nolabel
        :placeholder="$t('search.mediateagentname')"
      ></m-input>
    </div>
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.AUTHORNAME"
        nolabel
        :placeholder="$t('search.author')"
      ></m-input>
    </div>
    <div class="col-12">
      {{ $t("search.city") }}
      <m-select
        class="search-form-field"
        v-model="search.CITYID"
        nolabel
        :options="options.city"
      ></m-select>
    </div>
    <div class="col-12">
      {{ $t("search.county") }}
      <m-select
        class="search-form-field"
        v-model="search.COUNTYID"
        nolabel
        :options="options.county"
      ></m-select>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        BROKERAGEID: null,
        AGENTTITLE: null,
        AUTHORNAME: null,
        CITYID: null,
        COUNTYID: null,
      },
      options: {
        city: [],
        county: [],
        brokerage: [],
      },
    };
  },
  mounted() {
    this.getBrokerage();
    this.getCity();
  },
  methods: {
    getBrokerage() {
      api
        .getBrokerage()
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            this.options.brokerage = res.data.data.rows.map((item) => {
              return { text: item.BROKERAGETITLE, value: item.ID };
            });
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        });
    },
    getCity() {
      api
        .getCity()
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            this.options.city = res.data.data.rows.map((item) => {
              return { text: item.CITYNAME, value: item.ID };
            });
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        });
    },
    getCountyWidthCityId(id) {
      api
        .getCountyWidthCityId(id)
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            this.options.county = res.data.data.rows.map((item) => {
              return { text: item.COUNTYNAME, value: item.ID };
            });
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        });
    },
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        BROKERAGEID: null,

        AGENTTITLE: null,
        AUTHORNAME: null,
        CITYID: null,
        COUNTYID: null,
      };
    },
  },
  watch: {
    "search.CITYID"(id) {
      this.getCountyWidthCityId(id);
    },
  },
};
</script>

<style></style>
